import alertIcon from '@/assets/images/alert-triangle.svg';
import { DMImage } from '@/components/custom-image/custom-image';
import { SkeletonLoader } from '@/components/skeleton-loader';

type CourseDetailsHeaderProps = {
  title: string;
  description: string;
  createdBy?: string;
  updatedOn?: string;
};

function CourseDetailsHeader({
  title,
  description,
  createdBy,
  updatedOn,
}: CourseDetailsHeaderProps) {
  return (
    <div className='flex flex-col gap-2 lg:w-3/5 px-2'>
      <h1 className='mt-5 text-2xl lg:text-3xl'>{title ?? <SkeletonLoader />}</h1>
      <p className='text-sm leading-6 mt-2'>{description}</p>

      <div>
        <p className='mt-3 font-medium text-sm'>
          Created By{' '}
          <span className='text-brand-primary-hover'>{createdBy ?? <SkeletonLoader />}</span>
        </p>

        <p className='mt-2 flex gap-2 items-center font-medium text-sm'>
          <DMImage src={alertIcon} alt='Home Icon' width={18} height={18} /> Last updated{' '}
          {updatedOn ?? <SkeletonLoader />}
        </p>
      </div>
    </div>
  );
}

export default CourseDetailsHeader;
